module.exports = __webpack_public_path__ + "static/media/Notification.fc82fd22.svg";